import { IMAGES, OFFICES } from "../../data/content";

const DOT_PATTERN = {
  backgroundImage: "radial-gradient(rgba(255,255,255,0.14) 1px, transparent 1px)",
  backgroundSize: "14px 14px",
};

export const GlobalPresence = () => (
  <section className="bg-[#0A0A0A] px-6 lg:px-12 py-24 lg:py-32" data-testid="global-presence-section">
    <p className="font-mono text-xs tracking-[0.35em] text-white/50 flex items-center gap-4">
      GLOBAL PRESENCE <span className="inline-block w-16 h-px bg-white/20" />
    </p>
    <div className="mt-12 grid lg:grid-cols-2 gap-16 items-start">
      <div>
        <h2 className="font-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-white" data-testid="presence-headline">
          One Enterprise. Multiple Geographies.
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
          Working with governments and institutions across key regions to build
          intelligent systems for a more stable, prosperous and connected world.
        </p>
        <div className="mt-12 hidden lg:grid grid-cols-2 gap-0 border border-white/10">
          <div className="h-56 opacity-60" style={DOT_PATTERN} aria-hidden="true" />
          <div className="relative h-56 overflow-hidden">
            <img
              src={IMAGES.presenceCity}
              alt="Metropolitan skyline at dusk"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0A0A0A]/30" />
            <p className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.3em] text-white/80">
              LOCAL INSIGHT · GLOBAL IMPACT
            </p>
          </div>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 border border-white/10">
        {OFFICES.map((o, i) => (
          <div
            key={o.region}
            data-testid={`office-${o.region.toLowerCase().replace(/\\s+/g, "-")}`}
            className={`p-8 border-white/10 ${i % 2 === 1 ? "sm:border-l" : ""} ${i > 1 ? "border-t" : ""} max-sm:border-t max-sm:first:border-t-0`}
          >
            <p className="font-mono text-[10px] tracking-[0.3em] text-white/40">{o.region}</p>
            <div className="mt-4 space-y-1">
              {o.lines.map((l) => (
                <p key={l} className="text-sm leading-relaxed text-white/75">
                  {l}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
